import { useEffect, useState } from 'react';
export const DEBOUNCE_SEARCH_MS = 300;
export function useDebounceSearch(searchTerm, customDebounceMs = DEBOUNCE_SEARCH_MS) {
  const [debouncedValue, setDebouncedValue] = useState(searchTerm);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchTerm);
    }, customDebounceMs);
    return () => clearTimeout(handler);
  }, [customDebounceMs, searchTerm]);
  return debouncedValue;
}